import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Approach from './components/Approach';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Parents from './components/Parents';
import Contact from './components/Contact';
import Footer, { FinalCta } from './components/Footer';
import Privacy from './components/Privacy';
import NotFound from './components/NotFound';

export default function App() {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  const missing = window.location.pathname !== '/' && window.location.pathname !== '/index.html';
  return <><Header />{missing ? <NotFound /> : hash === '#privacy' ? <Privacy /> : <main><Hero /><About /><Approach /><Services /><Gallery /><Parents /><Contact /><FinalCta /></main>}<Footer /></>;
}